import { TWifiContent } from '../WifiContentState'

export const getWifiTextToEncode = (data: TWifiContent) =>
	`WIFI:T:${data.encryption};S:${data.ssid};P:${data.password};H:${data.hidden || ''};;`
